import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import {Query, Mutation} from 'react-apollo'
import get from 'lodash/get'
import {GET_SHIPPING_METHOD_BY_PROJECT_ID} from '../../../../../../../graphql/query'
import {
  REMOVE_SHIPPING_RULE,
  ADD_SHIPPING_RULE,
  UPDATE_SHIPPING_RULE,
} from '../../../../../../../graphql/mutation'
import {SectorContainer} from '../../../storeSettings/components/common'
import ShippingMethodModal from '../ShippingMethodModal'

class CustomShippingSection extends React.Component {
  state = {
    modalOpen: false,
    shippingRuleInModal: null,
  }

  handleOpenModal = shippingRule => {
    this.setState({
      modalOpen: true,
      shippingRuleInModal: shippingRule,
    })
  }

  handleCloseModal = () => {
    this.setState({
      modalOpen: false,
    })
  }

  onRemovePressRemove = async (shippingMethodId, removeGQL) => {
    await removeGQL({
      variables: {
        projectId: this.props.projectId,
        shippingMethodId,
      },
    })
  }

  render() {
    return (
      <Mutation
        mutation={REMOVE_SHIPPING_RULE}
        refetchQueries={[
          {
            query: GET_SHIPPING_METHOD_BY_PROJECT_ID,
            variables: {
              projectId: this.props.projectId,
            },
          },
        ]}
      >
        {(removeShippingRule, mutationObj) => {
          if (mutationObj.loading) return 'Loading...'
          if (mutationObj.error) return 'Error !'
          return (
            <Query
              query={GET_SHIPPING_METHOD_BY_PROJECT_ID}
              variables={{projectId: this.props.projectId}}
            >
              {({loading, error, data}) => {
                const shippingMethod = get(
                  data,
                  'getShippingMethodByProjectId',
                  [],
                )
                if (loading) return 'Loading...'
                if (error) return 'Error !'
                const productToShow = sku => {
                  return sku
                    .reduce((prev, curr) => {
                      const skuValue = [
                        get(curr.productType, '0.value', ''),
                        get(curr.productType, '1.value', ''),
                      ].join(' ')
                      return [
                        ...prev,
                        `${curr.productCode} ${skuValue}`,
                      ].filter(o => o)
                    }, [])
                    .join(',')
                }
                return (
                  <SectorContainer>
                    <div
                      style={{display: 'flex', justifyContent: 'space-between'}}
                    >
                      <h2>Shipping Rule</h2>
                      <Button
                        onClick={() => this.handleOpenModal(null)}
                        variant="contained"
                        color="secondary"
                      >
                        Add New Rule
                      </Button>
                    </div>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Type</TableCell>
                          <TableCell align="right">Products</TableCell>
                          <TableCell align="right">Shipping Method</TableCell>
                          <TableCell align="right">Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {shippingMethod.map((shippingRule, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell component="th" scope="row">
                                {shippingRule.calculateType}
                              </TableCell>
                              <TableCell align="right">
                                <span
                                  style={{
                                    display: 'block',
                                    maxWidth: '250px',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                  {productToShow(shippingRule.productSKUs)}
                                </span>
                              </TableCell>
                              <TableCell align="right">
                                {shippingRule.method}
                              </TableCell>
                              <TableCell align="right">
                                <div>
                                  <Button
                                    variant="contained"
                                    onClick={() =>
                                      this.handleOpenModal(shippingRule)
                                    }
                                    color="secondary"
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="contained"
                                    style={{
                                      backgroundColor: 'red',
                                      color: 'white ',
                                      marginLeft: 15,
                                    }}
                                    onClick={() => {
                                      this.onRemovePressRemove(
                                        shippingRule.id,
                                        removeShippingRule,
                                      )
                                    }}
                                  >
                                    Remove
                                  </Button>
                                </div>
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                    <Mutation
                      mutation={UPDATE_SHIPPING_RULE}
                      refetchQueries={[
                        {
                          query: GET_SHIPPING_METHOD_BY_PROJECT_ID,
                          variables: {
                            projectId: this.props.projectId,
                          },
                        },
                      ]}
                    >
                      {(updateShippingRule, mutationAddData) => {
                        if (mutationAddData.loading) return 'Loading...'
                        return (
                          <Mutation
                            mutation={ADD_SHIPPING_RULE}
                            refetchQueries={[
                              {
                                query: GET_SHIPPING_METHOD_BY_PROJECT_ID,
                                variables: {
                                  projectId: this.props.projectId,
                                },
                              },
                            ]}
                          >
                            {(addShippingRule, mutationUpdateData) => {
                              if (mutationUpdateData.loading) { return 'Loading...' }
                              return (
                                <ShippingMethodModal
                                  handleClose={this.handleCloseModal}
                                  shippingRule={this.state.shippingRuleInModal}
                                  open={this.state.modalOpen}
                                  onSave={
                                    this.state.shippingRuleInModal
                                      ? updateShippingRule
                                      : addShippingRule
                                  }
                                  projectId={this.props.projectId}
                                  skuIdExistInShippingMethod={(() => {
                                    const existShippingMethod = get(
                                      data,
                                      'getShippingMethodByProjectId',
                                      [],
                                    )
                                    return existShippingMethod.reduce(
                                      (ac, cv) => {
                                        return {
                                          ...ac,
                                          [cv.method]: [
                                            ...ac[cv.method],
                                            ...cv.productSKUs.map(
                                              sku => sku.id,
                                            ),
                                          ],
                                        }
                                      },
                                      {EXPRESS: [], STANDARD: []},
                                    )
                                  })()}
                                />
                              )
                            }}
                          </Mutation>
                        )
                      }}
                    </Mutation>
                  </SectorContainer>
                )
              }}
            </Query>
          )
        }}
      </Mutation>
    )
  }
}

export default CustomShippingSection



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/shipping/components/customShippingSection/index.js